import { UnitStatusSearchForm } from '@mark43/cad-api';
import { formatMonthDayHoursMinutes } from '../common/helpers/utils';
import { FilterSummary } from '../search-windows/filter-summary';
import { FiltersSummary } from '../search-windows/filters-summary';

export function UnitInformationFiltersSummary({ form }: { form: UnitStatusSearchForm }) {
    return (
        <FiltersSummary title="Unit Information">
            <FilterSummary label="Units" options={form.units} />
            <FilterSummary label="Personnel" options={form.personnel} />
            <FilterSummary label="Plate #" options={form.vehicleTags} />
            <FilterSummary label="Unit D-Areas" options={form.dispatchAreas} />
            <FilterSummary label="Stations" options={form.stations} />
            <FilterSummary label="Hospitals" options={form.hospitals} />
            <FilterSummary label="Transitioned By" options={form.transitionedBy} />
            <FilterSummary label="Agencies" options={form.agencyProfiles} />
            <FilterSummary label="Agency Type" option={form.agencyType} />
            <FilterSummary label="Narrative Keywords" stringValue={form.narrativeKeywords} />
            <FilterSummary label="Time Range" option={form.timeRangeOption} />
            <FilterSummary
                label="Date Range Start"
                stringValue={
                    form.dateRange?.start
                        ? formatMonthDayHoursMinutes(form.dateRange.start)
                        : undefined
                }
            />
            <FilterSummary
                label="Date Range End"
                stringValue={
                    form.dateRange?.end ? formatMonthDayHoursMinutes(form.dateRange.end) : undefined
                }
            />
            <FilterSummary label="Statuses" options={form.unitStates} />
        </FiltersSummary>
    );
}
